import { get } from 'lodash';
// import { components } from 'apiTyped/types';

export const formatDataOptions = (data, { value, label }) => {
  return data.map((data) => ({
    value: get(data, value),
    label: get(data, label)
  }));
};

export const formatDataCheckOptions = (
  data,
  { value, label, is_default, selected_option }
) => {
  return data.map((data, index) => ({
    value: get(data, value),
    label: get(data, label),
    checked: selected_option
      ? selected_option === index + 1
      : get(data, is_default)
  }));
};

export const getSubmissionFileName = (filePath) => {
  const fileName = filePath.substring(filePath.lastIndexOf('/') + 1);
  return fileName.split('.')[0];
};
